class InsurancePremium {

    timer;

    annualPremiumElement;
    monthlyPremiumElement;
    ageAtFirstPremiumDateElement;
    quickCalculatorResultElements;

    ageAtFirstPremiumDate;
    duration;
    insuredAmount;
    hasCoInsuredChildren;

    constructor() {
        this.annualPremiumElement = document.querySelector('#annualPremium');
        this.monthlyPremiumElement = document.querySelector('#monthlyPremium');
        this.ageAtFirstPremiumDateElement = document.querySelector('#ageAtFirstPremiumDate');
        this.quickCalculatorResultElements = document.querySelectorAll('.premiumCalculatorResult');

        $('#birthdate,#duration,#insuredAmount,#firstPremiumDate,[name="hasCoInsuredChildren"]')
            .on('change dp.change', this.onInsuranceChanged.bind(this))
        ;

        if (this.annualPremiumElement && document.querySelector('#birthdate').value) {
            this.onInsuranceChanged();
        }
    }

    onInsuranceChanged() {
        if (!document.querySelector('#firstPremiumDate')) {
            return;
        }

        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.getInsurancePremium(), 1000);
    }

    getInsurancePremium() {
        this.ageAtFirstPremiumDate = this.getAgeAtFirstPremiumDate();
        this.duration = +document.querySelector('#duration').value;
        this.insuredAmount = +document.querySelector('#insuredAmount').value;
        this.hasCoInsuredChildren = document.querySelector('[name="hasCoInsuredChildren"][value="1"]').checked;
        this.ageAtFirstPremiumDateElement.value = this.ageAtFirstPremiumDate;

        this.requestInsurancePremium().then(insurancePremium => {
            if (insurancePremium.annually) {
                this.annualPremiumElement.value = '€' + insurancePremium.annually.toLocaleString(
                    'nl-NL',
                    { maximumFractionDigits: 2 }
                );
            }
            if (insurancePremium.monthly) {
                this.monthlyPremiumElement.value = '€' + insurancePremium.monthly.toLocaleString(
                    'nl-NL',
                    { maximumFractionDigits: 2 }
                );
            }
            if (this.quickCalculatorResultElements) {
                this.quickCalculatorResultElements.forEach(element => element.classList.remove('hidden'));
            }
            if (insurancePremium.error) {
                this.annualPremiumElement.value = this.monthlyPremiumElement.value = insurancePremium.error;
            }
        });
    }

    requestInsurancePremium() {
        return new Promise(resolve => {
            $.ajax({
                url: '/api/insurance-premium.json',
                data: {
                    ageAtFirstPremiumDate: this.ageAtFirstPremiumDate,
                    duration: this.duration,
                    insuredAmount: this.insuredAmount,
                    hasCoInsuredChildren: +this.hasCoInsuredChildren,
                },
                success: response => {
                    resolve(response);
                },
                error: () => {
                    resolve(null);
                }
            });
        });
    }

    formatDatepickerDate(date) {
        const parts = date.split('-');
        if (parts.length < 3) {
            return;
        }
        return new Date(`${parts[2]}-${parts[1]}-${parts[0]}T00:00:00`);
    }

    getAgeAtFirstPremiumDate() {
        let birthDateValue = document.querySelector('#birthdate').value || '';
        const birthDate = birthDateValue.split('-')[0].length !== 4
            ? this.formatDatepickerDate(birthDateValue)
            : new Date(`${birthDateValue}T00:00:00`);

        const firstPremiumDateValue = document.querySelector('#firstPremiumDate').value;
        const firstPremiumDate = firstPremiumDateValue.split('-')[0].length !== 4
            ? this.formatDatepickerDate(firstPremiumDateValue)
            : new Date(`${firstPremiumDateValue}T00:00:00`);

        return moment(firstPremiumDate).diff(birthDate, 'years');
    }
}
